/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	console.log(a);
	console.log(v);

	const slider = () => {
		if($('.recruit-slide01').length) {
			$('.recruit-slide01').slick({
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				dots: false,
				infinite: true,
				draggable: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							draggable: true,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							draggable: true,
							arrows: false,
						}
					}
				]
			});
		}
	};

	slider();

})(window.jQuery, window.FUNCTIONS);
